import { render } from "./IconDot.vue?vue&type=template&id=590a3924"
import script from "./IconDot.vue?vue&type=script&lang=js"
export * from "./IconDot.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__